import React, { FC } from "react";
import { createUseStyles, useTheme } from "react-jss";
import styles from "./styles";

interface Props {
  text?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  showBackground?: boolean;
  Icon?: React.FunctionComponent;
  children?: any;
  className?: string;
}

const MediaIcon: FC<Props> = (props: Props) => {
  const useStyles = createUseStyles(styles);
  const theme = useTheme();

  const classes = useStyles({ theme, ...props });
  const { text, Icon, children, className } = props;

  return (
    <>
      {children || (
        <div className={classes.container}>
          {text && <span className={classes.text}>{text}</span>}
          {Icon && (
            <span
              className={className || classes.iconContainer}
              data-testid="svgStyle"
            >
              <Icon data-testid="svg" />
            </span>
          )}
        </div>
      )}
    </>
  );
};
MediaIcon.defaultProps = {
  text: "",
  showBackground: true,
  Icon: undefined,
  children: null,
  className: "",
};
export default MediaIcon;
